<template>
  <div id="map-controls-sidebar-floating-unit">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeFloatingUnit"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">海上設置物</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_FLOATING_UNIT(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" color="#828282" />

        <div class="search-area">
          <input
            type="text"
            v-model="searchKeyword"
            placeholder="海上設置物を検索"
          />
          <feather-icon
            class="search-icon"
            icon="SearchIcon"
            svgClasses="h-5 w-5"
          />
        </div>

        <div class="pl-5">
          <div v-if="ownFloatingUnits.length === 0 && searchKeyword === ''">
            <span>登録されている海上設置物はありません。</span>
          </div>
          <div
            v-if="ownFloatingUnits.length === 0 && searchKeyword.length !== 0"
          >
            <span>検索条件に一致する海上設置物が見つかりませんでした。</span>
          </div>
        </div>
        <ul class="pb-20 floating-unit-list-scroller">
          <li
            v-for="floatingUnit in ownFloatingUnits"
            :key="floatingUnit.device_id"
          >
            <floating-unit-card
              class="m-4"
              :floatingUnit="floatingUnit"
            ></floating-unit-card>
          </li>
        </ul>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import FloatingUnitCard from "./FloatingUnitCard.vue";

import { createNamespacedHelpers } from "vuex";
import AuthService from "@/services/authService";

const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  components: {
    FloatingUnitCard,
  },
  props: {
    map: Object,
  },
  data() {
    return {
      user: Object,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      searchKeyword: "",
    };
  },
  computed: {
    ...mapGettersOfLiveMap(["getOwnFloatingUnits"]),
    ...mapStateOfLiveMap({
      activeFloatingUnit: state => state.activeFloatingUnit,
      floatingUnits: state => state.floatingUnits,
    }),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    ownFloatingUnits() {
      let ofu = this.getOwnFloatingUnits(Number(this.user.id));
      if (this.searchKeyword === "") {
        return ofu;
      }
      let searchKeyword = this.searchKeyword;
      return ofu.filter(el => {
        // label は未設定(null)の場合があるため空文字にフォールバックする
        return (el.label || "")
          .toLowerCase()
          .includes(searchKeyword.toLowerCase());
      });
    },
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_ACTIVE_FLOATING_UNIT"]),
  },
  async created() {
    this.user = await AuthService.getUser();
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-floating-unit {
  .search-area {
    flex: auto;
    position: relative;
    margin-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    input {
      color: $aisea-pure-white;
      font-size: 15px;
      box-sizing: border-box;
      width: 100%;
      margin: 8px 0;
      padding: 0.5em 0.5em 0.5em 40px;
      transition: 0.3s;
      background: $aisea-blue-gray;
      border: 1px solid transparent;
      border-radius: 6px;
      outline: none;
      &::placeholder {
        color: #a0a3a7;
      }
      &:focus {
        box-sizing: border-box;
        border: 1px solid $aisea-blue;
      }
    }
    .search-icon {
      position: absolute;
      top: 7px;
      left: 1.3rem;
      padding: 9px 8px;
      transition: 0.3s;
      color: #a0a3a7;
    }
  }

  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }

  .floating-unit-list-scroller {
    width: 100%;
    height: 88vh;
    overflow: scroll;
    scrollbar-color: #3d4656 #2c3241;
    scrollbar-width: thin;
  }
}
</style>
